export const refs = {
  artistsList: document.querySelector('.artists-list'),
  containerEL: document.querySelector('.container'),
  loader: document.querySelector('.loader'),
  artistsPagination: document.querySelector('#artists-pagination'),
  feedbackContainer: document.querySelector('.section-feedback .container'),
  genreSelect: document.querySelector('#genre-select'),
  sortSelect: document.querySelector('#sorting-select'),
  searchInput: document.querySelector('.filters-search-input'),
  searchBtn: document.querySelector('.filters-search-btn'),
  emptyResetBtn: document.querySelector('.empty-reset-btn'),

  toggleBtn: document.querySelector('.filters-toggle-btn'),
  filtersWrapper: document.querySelector('.filters-wrapper'),
  artistsLoader: document.querySelector('.artists-loader'),
  modalArtistLoader: document.querySelector('.modal-artist-loader'),

  filtersMenu: document.querySelector('.filters-form-container'),
  filtersMenuIcon: document.querySelector('.filters-menu-icon'),
  filtersMenuBtn: document.querySelector('.filters-menu-btn'),

  filtersSortingBtn: document.querySelector('[data-sorting-button'),
  filtersSortingIcon: document.querySelector('.filters-sorting-icon'),
  filtersSortingMenu: document.querySelector('#sorting-select'),

  filtersGenreBtn: document.querySelector('[data-genre-button'),
  filtersGenreIcon: document.querySelector('.filters-genre-icon'),
  filtersGenreMenu: document.querySelector('#genre-select'),

  filtersSortingList: document.querySelector('#sorting-select'),
  filtersGenreList: document.querySelector('#genre-select'),
  filtersResetBtn: document.querySelector('.filters-reset-btn'),
  filtersResetBtnMob: document.querySelector('.filters-reset-btn-mob'),
  headerEl: document.querySelector('.header'),
  artistsEl: document.querySelector('.section-artists'),

  divForSkeletonFeed: document.querySelector('.sceleton-feedback'),
};
